import { styled, css } from "styled-components";

export const Col = styled.div<{ $span: number }>`
  display: flex;
  flex-direction: column;
  ${({ $span, theme }) => css`
    grid-column: span ${Math.min($span, 12)};

    ${theme.breakpoints.lg.query} {
      grid-column: span ${Math.min($span, 6)};
    }

    ${theme.breakpoints.sm.query} {
      grid-column: span ${Math.min($span, 3)};
    }
    ${theme.breakpoints.xs.query} {
      grid-column: span ${Math.min($span, 3)};
    }
  `}
`;

export const GridContainer = styled.div<{
  $gap?: number;
  $justifyContent?: string;
  $autoMaxWidth?: boolean;
  $alignItems?: string;
  $width?: string;
  $padding?: {
    vertical: number;
    horizontal: number;
  };
  $reverse?: boolean;
}>`
  display: grid;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  align-items: ${({ $alignItems }) => $alignItems};
  grid-template-columns: repeat(12, 1fr);
  gap: ${({ $gap }) => $gap}px;
  width: ${({ $width }) => $width};
  ${({ $autoMaxWidth, theme }) =>
    $autoMaxWidth
      ? css`
          max-width: ${theme.content.maxWidth}px;
          margin: 0 auto;
        `
      : css`
          max-width: 100%;
        `}
  ${({ $padding }) =>
    $padding &&
    css`
      padding: ${$padding.vertical}px ${$padding.horizontal}px;
    `}
    
    ${({ theme }) => css`
    ${theme.breakpoints.lg.query} {
      grid-template-columns: repeat(6, 1fr);
    }

    ${theme.breakpoints.sm.query} {
      grid-template-columns: repeat(3, 1fr);
    }

    ${theme.breakpoints.xs.query} {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
    ${({ $reverse }) =>
    $reverse &&
    css`
      direction: rtl;
      > * {
        direction: ltr;
      }
    `}
    
    ${Col} {
    justify-content: ${({ $justifyContent }) => $justifyContent};
    align-items: ${({ $alignItems }) => $alignItems};
    width: 100%;
    height: 100%;

    > div > div {
      display: flex;
      flex-direction: column;
      justify-content: ${({ $justifyContent }) => $justifyContent};
      align-items: ${({ $alignItems }) => $alignItems};
    }
  }
`;
